export class ToastImpl {
    constructor(gluePromise) {
        this.gluePromise = gluePromise;
        this.frequencyMap = {};
        this.gluePromise.then((g) => this.glue = g);
    }
    toast(topic, frequency, identifier, message, params) {
        const maybeOnce = frequency === "ONCE-SINCE-STARTUP" ? 1 : 0;
        const maxCount = params?.maxCount ?? maybeOnce ?? 0;
        if (maxCount && this.frequencyMap[identifier] >= maxCount) {
            return;
        }
        if (maxCount) {
            this.frequencyMap[identifier] = maxCount;
        }
        this.glue.notifications.raise({
            title: topic ?? identifier ?? "",
            body: message,
            panelExpiry: (params?.duration ?? 15000) / 1000
        });
    }
    alert(topic, frequency, identifier, message, params) {
        return this.toast(topic, frequency, identifier, message, params);
    }
}
